import { Dropdown, Select, Tooltip } from "antd";
import React, { useEffect, useState, useRef } from "react";

import { BasicMenu } from "./menus";
import { ContactsMenu } from "./contactmenus";
import { Cookie, hassAccess } from "../../base/utils";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import { ChatState, Loading } from "../../base/models/model";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { reportsRoutes, ROLES, settinRoutes } from "../../base/constant";
import { ReportsMenu } from "./reportmenus";
import { sidebarActions } from "../../store/slices/main_layout_slice/sidebar_slice";
import { useDispatcher } from "../../custom_hooks/use_app_dispatch";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
// import { useTour } from "@reactour/tour";
import Group from "../../styles/images/Group.svg";
import myaccount from "../../styles/images/myaccount.svg";
import { knowledgeBaseActions } from "../../store/slices/knowledgebasebot/knowledgebot";
import { supervisorContactDataSliceActions } from '../../store/slices/supervisor_contact/contactsData';
import menu1 from "../../styles/images/leftmenu/menu1.svg";
import menu2 from "../../styles/images/leftmenu/menu2.svg";
import menu3 from "../../styles/images/leftmenu/menu3.svg";
import menu4 from "../../styles/images/leftmenu/menu4.svg";
import menu5 from "../../styles/images/leftmenu/menu5.svg";
import menu6 from "../../styles/images/leftmenu/menu6.svg";
import menu7 from "../../styles/images/leftmenu/menu7.svg";
import menu8 from "../../styles/images/leftmenu/menu8.svg";
import menu9 from "../../styles/images/leftmenu/menu9.svg";
import menu1active from "../../styles/images/leftmenu/menu1active.svg";
import menu2active from "../../styles/images/leftmenu/menu2active.svg";
import menu3active from "../../styles/images/leftmenu/menu3active.svg";
import menu4active from "../../styles/images/leftmenu/menu4active.svg";
import menu5active from "../../styles/images/leftmenu/menu5active.svg";
import menu6active from "../../styles/images/leftmenu/menu6active.svg";
import menu7active from "../../styles/images/leftmenu/menu7active.svg";
import menu8active from "../../styles/images/leftmenu/menu8active.svg";
import menu9active from "../../styles/images/leftmenu/menu9active.svg";
import { UserSettingsActions } from "../../store/slices/settings_slice/user_settings_slice";
import { CoreServices } from "../../base/service/apiServices";

function CustomeMenu(props: any) {
  const navigate: any = useNavigate();
  const dispatch = useDispatcher();
  const reportsMenuValue: Loading = useSelector((state: any) => state.sideBar.reportsMenuValue);
  const settingsMenuValue: Loading = useSelector((state: any) => state.sideBar.settingsMenuValue);
  const sideBarOverlaySettings: Loading = useSelector((state: any) => state.sideBar.sideBarOverlaySettings);

  const sideBarOverlayReports: Loading = useSelector((state: any) => state.sideBar.sideBarOverlay);
  const contactsMenuValue: Loading = useSelector((state: any) => state.sideBar.contactsMenuValue);
  const mainValue: any = useSelector((state: any) => state.sideBar.mainValue);
  const sideBarOverlayContacts: Loading = useSelector((state: any) => state.sideBar.sideBarOverlayContacts);
  const Menucollapse: Loading = useSelector((state: any) => state.sideBar.Menucollapse);
  const [uparrows, setuparrows] = useState(false);
  const [uparrows1, setuparrows1] = useState(false);
  const [uparrows3, setuparrows3] = useState(false);
  const [currentSelectedItem, setCurrentSelectedItem] = useState<any>(null);
  const [myAcc, setMyAcc] = useState<any>(false);
  const [windowClick, setWindowClick] = useState<any>(0)
  const productid = GetItemFromStorage(LocalStorage.PRODUCT_ID)
  const planId: any = GetItemFromStorage(LocalStorage.PLAN_ID);
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const [show, setShow] = useState<boolean>();
  const [select2, setSelect2] = useState<boolean>(false);
  const LoginUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);

  let { servicePlan, internalChatDetails } = chatReducer;
  const uparrow = () => {
    setuparrows(!uparrows);
  };
  const uparrow1 = () => {
    setuparrows1(!uparrows1);
  };
  const uparrow3 = () => {
    setuparrows3(!uparrows3);
  };

  const [activity, setActivity] = useState(false);

  const handleMouseOverReports = () => {
    dispatch(sidebarActions.sideBarOverlayReports({ sideBarOverlayReports: true }));
  };
  const handleMouseOverSettings = () => {
    dispatch(sidebarActions.sideBarOverlaySettings({ sideBarOverlaySettings: true }));
  };
  const handleMouseOverContacts = () => {
    dispatch(sidebarActions.sideBarOverlayContacts({ sideBarOverlayContacts: true }));
  };
  const handleMouseOutReports = () => {
    dispatch(sidebarActions.sideBarOverlayReports({ sideBarOverlayReports: false }));
  };
  const handleMouseOutSettings = () => {
    dispatch(sidebarActions.sideBarOverlaySettings({ sideBarOverlaySettings: false }));
  };
  const handleMouseOutContacts = () => {
    dispatch(sidebarActions.sideBarOverlayContacts({ sideBarOverlayContacts: false }));
  };
  const reportsMenu = (
    <>
      {/* <div className="submenuAccordionOverlay mhide">
        <ReportsMenu />
      </div> */}
    </>
  );
  const settingsMenu = (
    <>
      <div className="submenuAccordionOverlay mhide">
        <BasicMenu />
      </div>
    </>
  );
  const contactsMenu = (
    <>
      <div className="submenuAccordionOverlay mhide">
        <ContactsMenu />
      </div>
    </>
  );

  const doNavigate = (value: any, selectedValue: any) => {
    dispatch(sidebarActions.leftMenuValues({ mainValue: selectedValue }));
    dispatch(sidebarActions.reportsMenu({ reportsMenuValue: "" }));
    dispatch(sidebarActions.settingsMenu({ settingsMenuValue: "" }));
    dispatch(sidebarActions.contactsMenu({ contactsMenuValue: "" }));
    navigate(`/${value}`);
    // setActivity(true);
  };
  // settingsMenuValue === "" ? "hasSubMenu  " :sideBarOverlaySettings  ?'hasSubMenu onHover' : 'hasSubMenu '

  const doDynamicClassNameReports = () => {
    if (currentSelectedItem === "report") {
      return "hasSubMenu activeleft ";
    } else if (currentSelectedItem === "" && sideBarOverlayReports) {
      return "hasSubMenu onHover ";
    } else {
      return "hasSubMenu";
    }
  };

  const doDynamicClassNameSettings = () => {
    if (settingsMenuValue) {
      return "hasSubMenu activeleft ";
    } else if (settingsMenuValue === "" && sideBarOverlaySettings) {
      return "hasSubMenu onHover ";
    } else {
      return "hasSubMenu";
    }
  };
  const doDynamicClassNameContacts = () => {
    if (currentSelectedItem === 'contacts') {
      return "hasSubMenu activeleft ";
    } else if (currentSelectedItem === "" && sideBarOverlayContacts) {
      return "hasSubMenu onHover ";
    } else {
      return "hasSubMenu";
    }
  };
  const doDynamicClassNameAnalytics = () => {
    // setSelect2(false)
    if (currentSelectedItem === "analytics") {
      return "hasSubMenu activeleft ";
    } else if (currentSelectedItem === "" && sideBarOverlayReports) {
      return "hasSubMenu onHover ";
    } else {
      return "hasSubMenu";
    }
  };
  const doDynamicClassNameCoChat = () => {
    if (currentSelectedItem === "cochat") {
      return "hasSubMenu activeleft ";
    } else if (currentSelectedItem === "" && sideBarOverlayReports) {
      return "hasSubMenu onHover ";
    } else {
      return "hasSubMenu";
    }
  };
  const doDynamicClassNameDashBoard = () => {
    // setSelect2(false)
    if (currentSelectedItem == 'dashboard') {
      return "hasSubMenu activeleft ";
    } else if (currentSelectedItem === "" && sideBarOverlayReports) {
      return "hasSubMenu onHover ";
    } else {
      return "hasSubMenu";
    }
  };
  const doDynamicClassNameChatBot = () => {
    if (currentSelectedItem === "chatbot") {
      return "hasSubMenu activeleft";
    } else if (currentSelectedItem === "" && sideBarOverlayReports) {
      return "hasSubMenu onHover ";
    } else {
      return "hasSubMenu";
    }
  };
  const doDynamicClassNameKnowledge = () => {
    if (currentSelectedItem === "websiteurl") {
      return "hasSubMenu activeleft ";
    } else if (currentSelectedItem === "" && sideBarOverlayReports) {
      return "hasSubMenu onHover ";
    } else {
      return "hasSubMenu";
    }
  };
  // const token: any = Cookie.get();
  const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  let supervisor = roleId && roleId.split(",").includes(ROLES.SUPERVISOR_ROLE_ID);
  let agent = roleId && roleId.split(",").includes(ROLES.AGENT_ROLE_ID);
  let admin = roleId && (roleId.split(",").includes(ROLES.ADMIN_ROLE_ID) || roleId.split(",").includes(ROLES.SUB_OWNER_ROLE_ID) || roleId.split(",").includes(ROLES.OWNER_ROLE_ID));


  function toggleShow() {
    setCurrentSelectedItem("settings");
    setShow(!show);
    setShow1(false);
    setShow2(false);
    setuparrows1(!uparrows1);
    setSelect2(!select2);
  }
  const [show2, setShow2] = useState<boolean>();
  const [select, setSelect] = useState<boolean>(true);

  function reportNavigation(selectedValue: any) {
    dispatch(sidebarActions.reportsMenu({ reportsMenuValue: selectedValue }));
    if (servicePlan?.product_id === "15") {
      navigate("/chatsreport");
    } else {
      navigate("/answeredcallreport");
    }

  }

  const [show1, setShow1] = useState<boolean>();
  function toggleShow1() {
    setShow1(!show1);
    setShow(false);
    setShow2(false);
    setuparrows(!uparrows);
  }

  const [show3, setShow3] = useState<boolean>();
  const [select3, setSelect3] = useState<boolean>(true);
  function toggleShow3() {
    setCurrentSelectedItem("contacts");
    //setShow1(false);
    // setShow(false);
    // setShow2(false);
    setShow3(!show3);
    setuparrows3(!uparrows3);
    setSelect3(!select3);
    setSelect2(false)
  }

  const [select4, setSelect4] = useState<boolean>(true);
  function selectnav() {
    setSelect4(!select4);
  }

  const handleClick = () => {

    setWindowClick((prevState: any) => prevState + 1)

  };
  useEffect(() => {
    if (windowClick > 1) {
      setWindowClick(0)
      setMyAcc(false)
    }

  }, [windowClick])



  useEffect(() => {


    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('click', handleClick);
    };

  }, []);

  const gotoWorktualapp = () => {
    window.open('https://myaccount.worktual.co.uk/overview', '_blank');
  }

  const location: any = useLocation();
  
  useEffect(() => {
    if (location.state?.notification && ['/myactivity', '/allactivity', '/AllActivity'].includes(window.location.pathname)) {
      agent ? setCurrentSelectedItem("myactivity") : setCurrentSelectedItem("allactivity")
    }
  }, [location.state?.notification]);
  


  useEffect(() => {
    if (['/contactscreen'].includes(window.location.pathname)) {
      setCurrentSelectedItem("contacts")
    } else if (['/CoChat'].includes(window.location.pathname)) {
      setCurrentSelectedItem("cochat")
    } else if (['/knowledgebase','/knowledgebaseinner'].includes(window.location.pathname)) {
      setCurrentSelectedItem("websiteurl")
    } else if (['/dynamicdashboard','/dashboard', '/agentDashboard', '/agentdashboard', '/standaloneDashboard', '/agentdashboardstandalone'].includes(window.location.pathname)) {
      setCurrentSelectedItem("dashboard")
    } else if (['/myactivity', '/allactivity', '/AllActivity'].includes(window.location.pathname)) {
      agent ? setCurrentSelectedItem("myactivity") : setCurrentSelectedItem("allactivity")
    }
    else if (reportsRoutes?.includes(window.location.pathname)) {
      setCurrentSelectedItem("report")
    }
    else if (['/flowscreen','/callFlow','/chatbot','/callFlowView'].includes(window.location.pathname)) {
      setCurrentSelectedItem("chatbot")
    }
    else if (settinRoutes?.includes(window.location.pathname)) {
      setCurrentSelectedItem("settings")
    }else if(['/recordingscreen'].includes(window.location.pathname)){
      setCurrentSelectedItem("recording")}

  }, [window.location.pathname])

  const getTourCount = () => {
    //FOR SETTINGS
    try {
      if (productid == "1") {
        return (admin && props.step === 8) ? true
          : (supervisor && props.step === 6) ? true : false
  
      } else if (productid == "15" && planId == '54') {
        return (admin && props.step === 6) ? true
          : (supervisor && props.step === 5) ? true : false
  
      } else if (productid == "15" && [55, 56].includes(planId)) {
        return (admin && props.step === 7) ? true
          : (supervisor && props.step === 5) ? true : false
      } else {
        return (admin && props.step === 6) ? true
          : (supervisor && props.step === 5) ? true : false
      }
    } catch (error) {
      return false
    }
  }
  const [internalChatUnRead_Count, setInternalChatUnread_Count] = useState(0)
  useEffect(()=>{
    const getInternalChat = () => {
      try {
        CoreServices.get(`/internal_chat?hostUserId=${LoginUserDetails?.UserID}`)
          .then((response) => {
            if (response?.data?.statusCode === 200) {
              const unRead = response?.data?.internalChatRes?.reduce((acc :any, item :any)=>{
                if(item.unreadCount){
                  acc = acc + (item?.unreadCount || 0)
                }
                  return acc
              }, 0)
              setInternalChatUnread_Count(unRead)
            }
          })
          .catch((error) => {
            console.error("Error fetching internal chat:", error);
          })
      } catch (error) {
        console.log(error)
      }
    };
    getInternalChat()

  },[internalChatDetails?.reload])

  return (
    <>
      {window.location.pathname !== "/customerscreen" &&
        <div className="">
          <ul className="rootMenu">
            {admin ? (
              <Tooltip
                placement="right" title="Dashboards" overlayClassName="customToolTip"
              >
                <li
                  className={doDynamicClassNameDashBoard()}
                  onClick={() => {
                    setCurrentSelectedItem("dashboard"); 
                    props.closeMenu();
                    {
                      hassAccess("Dashboard/dynamicDash") 
                        ?  doNavigate("dynamicdashboard", "ad") 
                        :  doNavigate("dashboard", "ad")
                      // productid !== "15" ?
                      //   doNavigate("dashboard", "ad") : doNavigate("standaloneDashboard", "sad")
                    }
                  }}
                  onTouchStart={() => {
                    setCurrentSelectedItem("dashboard"); 
                    props.closeMenu();
                    {
                      hassAccess("Dashboard/dynamicDash") 
                        ?  doNavigate("dynamicdashboard", "ad") 
                        :  doNavigate("dashboard", "ad")
                      // productid !== "15" ? doNavigate("agentDashboard", "sd") :
                      //   doNavigate("agentdashboardstandalone", "sad")
                    }
                  }}
                >
                  <div className={`menuTitle menuTitledashboard ${currentSelectedItem === "dashboard" ? "active" : ""}`}>
                    {/* <span className="icon__DashboardWhite24 first-step" />{" "} */}
                    <img src={menu1} />
                    <img className="first-step" src={menu1active} />
                    <span className="menuname fade">Dashboards</span>
                  </div>
                </li>
              </Tooltip>
            ) : (
              ""
            )}

            {supervisor ? (
              //<Tooltip placement="right" title={Menucollapse ? "Dashboard" : null} overlayClassName="customToolTip">
              <Tooltip placement="right" title="Dashboard" overlayClassName="customToolTip">
                <li
                  // className={mainValue === "sd" ? "activeleft" : ""}
                  className={doDynamicClassNameDashBoard()}
                  onClick={() => {
                    setCurrentSelectedItem("dashboard"); 
                    props.closeMenu();
                  
                      hassAccess("Dashboard/dynamicDash") 
                        ?  doNavigate("dynamicdashboard", "ad") 
                        :  doNavigate("dashboard", "ad")
                      // productid !== "15" ?
                      //   doNavigate("dashboard", "sd") : doNavigate("standaloneDashboard", "sad")
                  
                  }}
                  onTouchStart={() => {
                    setCurrentSelectedItem("dashboard"); 
                    props.closeMenu();
                    hassAccess("Dashboard/dynamicDash") 
                     ?  doNavigate("dynamicdashboard", "ad") 
                     :  doNavigate("dashboard", "ad")
                    // {
                    //   productid !== "15" ?
                    //     doNavigate("dashboard", "sd") : doNavigate("standaloneDashboard", "sad")
                    // }
                  }}
                >
                  <div className={`menuTitle menuTitledashboard ${(currentSelectedItem === "dashboard" || props.step === 0) ? "active" : ""}`}>
                    {/* <span className=" icon__DashboardWhite24 first-step" />{" "}  */}

                    <img src={menu1} />
                    <img className="first-step" src={menu1active} />
                    <span className="menuname fade">Dashboard</span>
                  </div>
                </li>
              </Tooltip>
            ) : (
              ""
            )}
            {agent ? (
              // <Tooltip placement="right" title={Menucollapse ? "Dashboard" : null} overlayClassName="customToolTip">
              // <AgentDashBoardKelvin
              // chatDash={chatDataFromAPI} />
              <Tooltip placement="right" title="Dashboard" overlayClassName="customToolTip">
                <li
                  // className={mainValue === "sd" ? "activeleft" : ""}

                  className={doDynamicClassNameDashBoard()}
                  onClick={() => {
                    setCurrentSelectedItem("dashboard"); 
                    props.closeMenu();
                     hassAccess("Dashboard/dynamicDash") 
                     ?  doNavigate("dynamicdashboard", "ad") 
                     :  doNavigate("dashboard", "ad")
                    // {
                    //   productid !== "15" ? doNavigate("agentDashboard", "sd") :
                    //     doNavigate("agentdashboardstandalone", "sad")
                    // }
                  }}
                  onTouchStart={() => {
                    setCurrentSelectedItem("dashboard"); 
                    props.closeMenu();
                    hassAccess("Dashboard/dynamicDash") 
                     ?  doNavigate("dynamicdashboard", "ad") 
                     :  doNavigate("dashboard", "ad")
                    // {
                    //   productid !== "15" ? doNavigate("agentDashboard", "sd") :
                    //     doNavigate("agentdashboardstandalone", "sad")
                    // }
                  }}
                >
                  <div className={`menuTitle menuTitledashboard ${(currentSelectedItem === "dashboard" || props.step === 0) ? "active" : ""}`}>
                    {/* <span className=" icon__DashboardWhite24 first-step" />{" "}  */}

                    <img  src={menu1} />
                    <img   className="first-step" src={menu1active} />
                    <span className="menuname fade">Dashboard</span>
                  </div>
                </li>
              </Tooltip>
            ) : (
              ""
            )}
            <Tooltip placement="right" title="Contacts" overlayClassName="customToolTip">
              <li id="area" className={doDynamicClassNameContacts()}
              // onMouseOver={handleMouseOverContacts}
              // onMouseOut={handleMouseOutContacts}
              >
                {/* <Dropdown
                overlay={contactsMenu}
                trigger={["click"]}
                getPopupContainer={(trigger) =>
                  trigger.parentNode as HTMLElement
                }
                overlayClassName="sdfsdfsdf"
              > */}
                <div className={(currentSelectedItem === "contacts" || props.step === 1) ? "menuTitle menuTitlecontacts active" : "menuTitle menuTitlecontacts"}
                  //  onClick={toggleShow3}
                  onClick={() => {
                    toggleShow3()
                    setCurrentSelectedItem("contacts"); 
                    props.closeMenu();
                    if (window.location.pathname != "/contactscreen") {
                      dispatch(supervisorContactDataSliceActions.reset())
                    }
                    navigate('/contactscreen')
                  }
                  }
                  onTouchStart={() => {
                    toggleShow3()
                    setCurrentSelectedItem("contacts"); 
                    props.closeMenu();
                    if (window.location.pathname != "/contactscreen") {
                      dispatch(supervisorContactDataSliceActions.reset())
                    }
                    navigate('/contactscreen')
                  }
                  }
                >
                  {/* <span className="icon__ContactsWhite24 second-step" />  */}

                  <img src={menu2} />
                  <img className="second-step" src={menu2active} />
                  <span className="menuname fade">Contacts</span>{" "}
                </div>
                {/* </Dropdown> */}
              </li>
            </Tooltip>
            {agent ? (
              // <Tooltip placement="right" title={Menucollapse ? "My Activity" : null} overlayClassName="c . ustomToolTip">
              <Tooltip placement="right" title="My Activity" overlayClassName="customToolTip">
                {/* <li className={mainValue === "mya"  ? "activeleft" : ""}> */}
                <li className={currentSelectedItem === "myactivity" ? "activeleft" : ""}>
                  <div
                    className={`menuTitle menuTitleactivity  ${currentSelectedItem === "myactivity" || props.step === 2 ? "active" : ""} `}
                    onClick={() => {
                      setCurrentSelectedItem("myactivity"); 
                      props.closeMenu();
                      doNavigate("myactivity", "mya");
                    }}
                    onTouchStart={() => {
                      setCurrentSelectedItem("myactivity"); 
                      props.closeMenu();
                      doNavigate("myactivity", "mya");
                    }}
                  >
                    {/* <span className=" icon__ChannelsWhite24 third-step" /> */}

                    <img src={menu3} />
                    <img className="third-step" src={menu3active} />
                    <span className="menuname fade">My&nbsp;Activity</span>
                  </div>
                </li>
              </Tooltip>
            ) : (""
            )}


            {(admin || supervisor) && <Tooltip placement="right" title="All Activity" overlayClassName="customToolTip">
              <li className={currentSelectedItem === "allactivity" ? "activeleft" : ""}>
                <div
                  className={`menuTitle menuTitleactivity  ${currentSelectedItem === "allactivity" || props.step === 2 ? "active" : ""} `}
                  onClick={() => {
                    setCurrentSelectedItem("allactivity"); 
                    props.closeMenu();
                    doNavigate("allactivity", "acv");
                  }}
                  onTouchStart={() => {
                    setCurrentSelectedItem("allactivity"); 
                    props.closeMenu();
                    doNavigate("allactivity", "acv");
                  }}
                >
                  {/* <span className=" icon__ChannelsWhite24 third-step" /> */}
                  <img src={menu3} />
                  <img className="third-step" src={menu3active} />
                  <span className="menuname fade">All&nbsp;Activity</span>
                </div>
              </li>
            </Tooltip>}

            {productid != 17 && (
              <Tooltip placement="right" title="Internal chat" overlayClassName="customToolTip">
                <li
                  className={doDynamicClassNameCoChat()}
                  onClick={() => {
                    setCurrentSelectedItem("cochat"); 
                    props.closeMenu();
                    navigate("/internalchat");
                  }}
                  onTouchStart={() => {
                    setCurrentSelectedItem("cochat"); 
                    props.closeMenu();
                    navigate("/internalchat");
                  }}
                >
                  <div className={`menuTitle menuinternal menuTitlecochat ${(currentSelectedItem === "cochat" || props.step === 3) && "active"}`}>
                    {/* <span className="icon__coChat24 fourth-step" />  */}

                    <img src={menu4} />
                    <img className="fourth-step" src={menu4active} />
                    {internalChatUnRead_Count > 0 && <p>{internalChatUnRead_Count}</p>}
                    <span className="menuname fade" >Internal Chat</span>{" "}
                  </div>
                </li>
              </Tooltip>
            )}
            {supervisor && productid != 17 && (
              <div >
                <Tooltip placement="right" title="Reports & Analytics" overlayClassName="customToolTip">
                  <li className={currentSelectedItem === "report" ? "hasSubMenu activeleft" : 'hasSubMenu'}>
                    <div
                      className={(currentSelectedItem === "report" || props.step === 4) ? "menuTitle reportsandAnalytics active" : "menuTitle reportsandAnalytics"}
                      onClick={() => {
                        setCurrentSelectedItem("report"); 
                        props.closeMenu();
                        navigate('/reportsmain')
                      }}
                      onTouchStart={() => {
                        setCurrentSelectedItem("report"); 
                        props.closeMenu();
                        navigate('/reportsmain')
                      }}
                    >
                      {/* <span className="icon__ChartWhite24 fifth-step" />  */}
                      <img src={menu7} />
                      <img className="fifth-step" src={menu7active} />
                      <span className="menuname fade">Reports & Analytics</span>{" "}
                    </div>
                  </li>
                </Tooltip>
              </div>
            )}
            {admin && productid != 17 && (
              <div>
                <li id="area">
                  <Tooltip placement="right" title="Reports & Analytics" overlayClassName="customToolTip">
                    <li className={currentSelectedItem === "report" ? "hasSubMenu activeleft" : 'hasSubMenu'}>
                      <div
                        className={(currentSelectedItem === "report" || props.step === 4) ? "menuTitle reportsandAnalytics active" : "menuTitle reportsandAnalytics"}
                        onClick={() => {
                          navigate('/reportsmain')
                          setCurrentSelectedItem("report"); 
                          props.closeMenu();
                        }}
                        onTouchStart={() => {
                          navigate('/reportsmain')
                          setCurrentSelectedItem("report"); 
                          props.closeMenu();
                        }}
                      >
                        {/* <span className="icon__ChartWhite24 fifth-step" />  */}
                        <img src={menu7} />
                        <img className="fifth-step" src={menu7active} />
                        <span className="menuname fade">Reports & Analytics</span>{" "}
                      </div>
                    </li>
                  </Tooltip>
                </li>
              </div>
            )}


            {admin && hassAccess("KnowledgeBase/Hide") && (<Tooltip placement="right" title="Knowledge base" overlayClassName="customToolTip">
              <li
                className={doDynamicClassNameKnowledge()}
                onClick={() => {
                  // if(!hassAccess('KnowledgeBase')){
                  //   dispatch(UserSettingsActions.setUpgradePlan(true))
                  //   props.closeMenu();
                  //   return
                  // }
                  setCurrentSelectedItem("websiteurl"); 
                  props.closeMenu();
                  navigate("/knowledgebasemain");
                  // navigate("/websiteurl");
                  dispatch(knowledgeBaseActions.changeBaseTab(false));
                }}
                onTouchStart={() => {
                  setCurrentSelectedItem("websiteurl"); 
                  props.closeMenu();
                  navigate("/knowledgebasemain");
                  // navigate("/websiteurl");
                  dispatch(knowledgeBaseActions.changeBaseTab(false));
                }}
              >
                <div className={`menuTitle knowledgebase ${(currentSelectedItem === "websiteurl" || props.step === 5) && "active"} fifth-step third-step2`}>
                  {/* <span className="icon__basebot24 sixth-step" />  */}
                  <img src={menu5} />
                  <img className="sixth-step" src={menu5active} />
                  <span className="menuname fade">Knowledge Base</span>{" "}
                </div>
              </li>
            </Tooltip>)}

            {/* {admin && (planId === 56 || planId === 33 || planId === 55) && <Tooltip placement="right" title="Work flow" overlayClassName="customToolTip">
            <li
              className={doDynamicClassNameChatBot()}
              onClick={() => {
                // setCurrentSelectedItem("chatbot");
                navigate("/flowscreen");
              }}
            >
              <div className={`menuTitle menuTitlecochat ${currentSelectedItem === "createbot" && "active"} fifth-step third-step2`}>
                <span className="icon__bot24" /> <span className="menuname fade">Work flow</span>{" "}
              </div>
            </li>
          </Tooltip>} */}

            {admin && ![54, 97, 96, 103, 107, 57].includes(planId) && productid != 17 && <Tooltip placement="right" title="Work flow" overlayClassName="customToolTip">
              <li
                className={doDynamicClassNameChatBot()}
                id="kbmenus"
                onClick={() => {
                  setCurrentSelectedItem("chatbot"); 
                  props.closeMenu();
                  navigate("/flowscreen");
                }}
                onTouchStart={() => {
                  setCurrentSelectedItem("chatbot"); 
                  props.closeMenu();
                  navigate("/flowscreen");
                }}
              >
                <div className={`menuTitle workflow ${(currentSelectedItem === "chatbot" || props.step === 6) && "active"} fifth-step third-step2`}>
                  {/* <span className="icon__bot24 seventh-step" />  */}
                  <img src={menu6} />
                  <img className="seventh-step" src={menu6active} />
                  <span className="menuname fade">Work flow</span>{" "}
                </div>
              </li>
            </Tooltip>}
 
            {(productid == 1 && hassAccess('Recording'))? (
              <Tooltip placement="right" title="Recording" overlayClassName="customToolTip">
                <li
                  onClick={() => {
                    setCurrentSelectedItem("recording");
                    props.closeMenu();
                    navigate("/recordingscreen")
                  }}
                  onTouchStart={() => {
                    setCurrentSelectedItem("recording");
                    props.closeMenu();
                    navigate("/recordingscreen")
                  }}
                >
                  <div className={`menuTitle menuTitledashboard ${(currentSelectedItem === "recording" || props.step === (admin ? 7 : supervisor ? 5 : 4)) ? "active" : ""}`}>
                    {/* {currentSelectedItem === "recording" ?
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.841 7.51794C20.6484 7.51794 20.4509 7.57234 20.2645 7.69174L17.475 9.47884L16.8828 9.85824V14.8969L17.475 15.2763L20.2645 17.0632C20.4509 17.1826 20.6486 17.2372 20.8412 17.2372C21.4453 17.2372 21.9995 16.7011 21.9995 15.9518V8.80344C21.9995 8.05434 21.4451 7.51794 20.841 7.51794Z" fill="#00DEA0" />
                        <path d="M16.3255 10.5726C16.2974 9.11753 16.3067 7.27583 15.1812 6.15223C14.0929 5.06573 12.5077 4.90923 11.0161 4.87233C10.3313 4.85393 9.7471 4.84473 9.1628 4.84473C8.5785 4.84473 7.9943 4.85393 7.3095 4.87233C5.8273 4.90923 4.2326 5.06573 3.1445 6.15223C2.0188 7.28503 2.0282 9.12673 2 10.5818V14.1825C2.0282 15.6376 2.0188 17.4793 3.1445 18.6028C4.2326 19.6893 5.818 19.846 7.3095 19.8827C7.9943 19.9011 8.5785 19.9104 9.1628 19.9104C9.7471 19.9104 10.3313 19.9011 11.0161 19.8827C12.4982 19.846 14.0929 19.6893 15.1812 18.6028C16.3067 17.4793 16.2975 15.6376 16.3255 14.1825C16.335 13.5839 16.3443 12.9761 16.335 12.3776C16.335 11.7791 16.335 11.1804 16.3255 10.5726Z" fill="#00DEA0" />
                        <path d="M11.4569 12.9947L10.0256 13.8211L8.59429 14.6475C8.11919 14.9218 7.52539 14.579 7.52539 14.0304V10.7249C7.52539 10.1764 8.11919 9.83347 8.59429 10.1078L10.0256 10.9342L11.4569 11.7606C11.9319 12.0349 11.9319 12.7204 11.4569 12.9947Z" fill="white" />
                      </svg>
                      :

                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.841 7.51794C20.6484 7.51794 20.4509 7.57234 20.2645 7.69174L17.475 9.47884L16.8828 9.85824V14.8969L17.475 15.2763L20.2645 17.0632C20.4509 17.1826 20.6486 17.2372 20.8412 17.2372C21.4453 17.2372 21.9995 16.7011 21.9995 15.9518V8.80344C21.9995 8.05434 21.4451 7.51794 20.841 7.51794Z" fill="white" />
                        <path d="M16.3255 10.5726C16.2974 9.11753 16.3067 7.27583 15.1812 6.15223C14.0929 5.06573 12.5077 4.90923 11.0161 4.87233C10.3313 4.85393 9.7471 4.84473 9.1628 4.84473C8.5785 4.84473 7.9943 4.85393 7.3095 4.87233C5.8273 4.90923 4.2326 5.06573 3.1445 6.15223C2.0188 7.28503 2.0282 9.12673 2 10.5818V14.1825C2.0282 15.6376 2.0188 17.4793 3.1445 18.6028C4.2326 19.6893 5.818 19.846 7.3095 19.8827C7.9943 19.9011 8.5785 19.9104 9.1628 19.9104C9.7471 19.9104 10.3313 19.9011 11.0161 19.8827C12.4982 19.846 14.0929 19.6893 15.1812 18.6028C16.3067 17.4793 16.2975 15.6376 16.3255 14.1825C16.335 13.5839 16.3443 12.9761 16.335 12.3776C16.335 11.7791 16.335 11.1804 16.3255 10.5726Z" fill="#fff" />
                        <path d="M11.4569 12.9947L10.0256 13.8211L8.59429 14.6475C8.11919 14.9218 7.52539 14.579 7.52539 14.0304V10.7249C7.52539 10.1764 8.11919 9.83347 8.59429 10.1078L10.0256 10.9342L11.4569 11.7606C11.9319 12.0349 11.9319 12.7204 11.4569 12.9947Z" fill="black" />
                      </svg>
                    } */}

                    <img src={menu8} />
                    <img className="tour-recordings" src={menu8active} />
                    <span className="menuname fade">Recordings</span>
                  </div>
                </li>
              </Tooltip>) : ""}

            {admin || supervisor ? (
              <Tooltip placement="right" title="Settings" overlayClassName="customToolTip">

                <li className={currentSelectedItem === "settings" ? "hasSubMenu activeleft" : 'hasSubMenu'}
                  onClick={() => {
                    navigate('/settingspage')
                    setCurrentSelectedItem("settings"); 
                    props.closeMenu();
                  }}
                  onTouchStart={() => {
                    navigate('/settingspage')
                    setCurrentSelectedItem("settings"); 
                    props.closeMenu();
                  }}
                  // className={doDynamicClassNameSettings()}
                  // onMouseOver={handleMouseOverSettings}
                  // onMouseOut={handleMouseOutSettings}
                  // onClick={()=>dispatch(sidebarActions.setCurrentActivePanel({panel: "settings"}))}
                  id="area"
                >
                  {/* <Dropdown
                overlay={settingsMenu}
                trigger={["click"]}
                getPopupContainer={(trigger) =>
                  trigger.parentNode as HTMLElement
                }
                overlayClassName="sdfsdfsdf"
              > */}
                  <div className={`menuTitle menuTitlesettings ${(currentSelectedItem === 'settings' || getTourCount()) && 'active'}`}>
                    {/* <span className="icon__SettingsWhite24 eigth-step tour-settings" />  */}

                    <img src={menu9} />
                    <img className="eigth-step" src={menu9active} />
                    <span className="menuname fade">Settings</span>{" "}
                  </div>
                  {/* {show && <div className="openedView">{settingsMenu}</div>} */}
                  {/* <div className={`menuTitle menuTitlesettings third-step ${select2 && "active"} `} onClick={toggleShow}>
                <span className="icon__SettingsWhite24" /> <span className="menuname fade">Settings</span>{" "}
                <span onClick={uparrow1} className={uparrows1 ? "icon__Downarrowmain16 active" : "icon__Downarrowmain16"}></span>
              </div>
              {show && <div className="openedView">{settingsMenu}</div>} */}

                  {/* </Dropdown> */}
                </li>
              </Tooltip>

            ) : (
              ""
            )}









            {/* <Tooltip placement="right" title="sdfdsf"
         overlayClassName='customToolTip'><li ><div className='menuTitle'><span className="icon__ContactsWhite24" /> <span className="menuname fade">Contacts</span></div></li></Tooltip> */}

            {/* <Tooltip placement="right" title="Contacts"><li><div className='menuTitle'><span className="icon__ContactsWhite24" /> <span className="menuname fade">Contacts</span></div></li></Tooltip> */}
            {/* <Tooltip placement="right" title="Tickets"><li><div className='menuTitle'><span className="icon__TicketsWhite24" /> <span className="menuname fade">Tickets</span></div></li></Tooltip>
                    <Tooltip placement="right" title="Meetings"><li><div className='menuTitle'><span className="icon__MeetingsWhite24" /> <span className="menuname fade">Meetings</span></div></li></Tooltip> */}
          </ul>
          {false && <div className="bottomnav" >
            <div className="globaliconbtm" onClick={() => {
              setMyAcc(!myAcc)
              setWindowClick(0)
            }} >
              <img src={Group} />
            </div>
            {myAcc &&
              <div className="rightnavbtm" onClick={gotoWorktualapp}>
                <img src={myaccount} />
                <span className="menuname" >Global My Account</span>
              </div>}
          </div>}

        </div >}
    </>
  );
}

export { CustomeMenu };
